import { render, staticRenderFns } from "./TambahNotes.vue?vue&type=template&id=ee8141a0&scoped=true&"
import script from "./TambahNotes.vue?vue&type=script&lang=js&"
export * from "./TambahNotes.vue?vue&type=script&lang=js&"
import style0 from "./TambahNotes.vue?vue&type=style&index=0&id=ee8141a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee8141a0",
  null
  
)

export default component.exports